import {
  CLASSES
} from "@/scripts/helpers/constants";

export default () => {
  const tabletBreakpoint = 767;
  if ($(window).width() < tabletBreakpoint) {
    $(".features-links-list").each(function () {
      const featuresList = $(this),
        hiddenItems = featuresList.find("li").slice(8),
        showMoreBtn = $(this).next(".text-centered").find(".show-more-features");

      hiddenItems.addClass(CLASSES.IS_HIDDEN);
      if (hiddenItems.length < 1) {
        showMoreBtn.hide();
      }

      if (hiddenItems.length > 0) {
        showMoreBtn.on("click", function (e) {
          e.preventDefault();
          const isExpanded = featuresList.hasClass(CLASSES.IS_OPEN);
          $(this).text(isExpanded ? "Show more" : "Show less");
          $(this).toggleClass(CLASSES.IS_ACTIVE);
          featuresList.toggleClass(CLASSES.IS_OPEN);
          hiddenItems.toggleClass(CLASSES.IS_HIDDEN);
        });
      }
    });
  }
}
